module.exports = __webpack_public_path__ + "static/img/6280_phase_function_Paper_Points.50d7c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6280_phase_function_Paper_Points.png
// module id = 9w84
// module chunks = 0